import MessageBannerComponent from './MessageBanner.component';

export * from './MessageBanner.component';
export default MessageBannerComponent;
